import { render, staticRenderFns } from "./profile-orders.vue?vue&type=template&id=33ccbee1&scoped=true&"
import script from "./profile-orders.ts?vue&type=script&lang=ts&"
export * from "./profile-orders.ts?vue&type=script&lang=ts&"
import style0 from "./profile-orders.scss?vue&type=style&index=0&id=33ccbee1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ccbee1",
  null
  
)

export default component.exports